export const SOCIAL_ASSISTANCE = "社会公益";
export const ZHIQI_NEWS = "琪志新闻";
export const ZHIQI_STORY = "品牌故事";
export const SHOW_MORE = "查看更多";